import React from 'react'
import {
    Chart as ChartJS,
    CategoryScale, LinearScale, BarElement,
    Title, Tooltip, Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
);

export var dataAux;
function GraficoMotos(props) {
    const { pedidos, valMaximo,tipo} = props;
    const getColor = (valor) => {
        var P = (valor / valMaximo);
        var R = Math.round(0xFF * (P));
        var G = Math.round(0xFF * (1 - P));
        var B = 0x00;
        return '#' + R.toString(16).padStart(2, '0') + G.toString(16).padStart(2, '0') + B.toString(16).padStart(2, '0');
    }
    const options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                display: false,
                position: 'top',
                labels:{
                    color:'#fff'
                }
            },
            title: {
                display: true,
                text: tipo=='R'?'Grafica Tiempo facturación':'Grafica Tiempo Moto',
                color: '#fff'
            },
        },
        scales: {
            y: {
                beginAtZero: true,
                max: 0.01,
                ticks: {
                    color: 'white',
                    fontSize: 12,
                }
            },
            x: {
                ticks: {
                    color: 'white',
                    fontSize: 12,
                }
            }
        }
    };
    const labels = pedidos.map((item) => item.MOTO);
    const data = {
        labels,
        datasets: [
            {
                label: tipo=='R'?"Demora Facturación":"Demora Moto",
                data: tipo=='R'?pedidos.map((item) => item.DIFF):pedidos.map((item) => item.RETRASO_MOTO),
                backgroundColor: tipo=='R'?pedidos.map((item) => getColor(item.DIFF)):pedidos.map((item) => getColor(item.RETRASO_MOTO)),
                barPercentage: 1.0,
                categoryPercentage: 1.0,
                max: 1,
            },
        ],
    }
    return (
        <div className='bg-dark w-100 container-fluid' style={{ height: "180px" }} >
            {true && <Bar options={options} data={data} width='100vh' updateMode='resize' />}
        </div>
    )
}

export default GraficoMotos
